import { render } from "./DojoTerminalsModal.vue?vue&type=template&id=83bee4f0"
import script from "./DojoTerminalsModal.vue?vue&type=script&lang=js"
export * from "./DojoTerminalsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__